/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getHCPReport = (params) =>
  makeApiCall(`/htar-crm/dashboard/reports/hcp`, 'GET', params);

export const getHCPReportExport = (params) =>
  makeApiCall(`/htar-crm/dashboard/reports/export/hcp`, 'GET', params);
